/** Relative time in the app's one format: 45s ago, 5m ago, 3h ago, 2d ago. */
export function timeAgo(dateStr: string, now = Date.now()): string {
  const diffMs = now - new Date(dateStr).getTime();
  if (diffMs < 0) return 'just now';
  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
